'use client';

export default function CalcomWidget({ calLink }) {
  // Simple direct link to cal.eu
  // This is more reliable than the embed widget for cal.eu
  const bookingUrl = `https://app.cal.eu/${calLink}`;

  return (
    <a
      href={bookingUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full bg-accent px-8 py-4 rounded-lg font-semibold hover:bg-accent/90 transition-all duration-300 shadow-lg hover:shadow-xl text-center"
      style={{ color: '#1a1a1a' }}
    >
      Verfügbare Zeiten anzeigen
    </a>
  );
}
